export const navLinks = [
    {label: "Home", path: "/home"},
    {label: "Education Hub", path: "/education-hub"},
    {
        label: "AI Tools",
        path: "/ai-tools",
        aliases: ["/vendor-details"] // any routes that also activate this menu
    },
];